<template>
  <ContentPage>
    <template #header>
      <Progress :step="2" :steps="5">
        <h2 class="py-1" style="line-height: 28px;">
          Verify your information and<br>set a password
        </h2>
        <!-- <div class="my-2 mx-8" style="font-size: 14px">
          This information will not be shared with anyone outside the app.
        </div> -->
      </Progress>
    </template>

    <v-form ref="form" @submit.prevent="submit">
      <v-container class="rounded-lg white">
        <v-text-field 
          v-model="name"
          outlined dense persistent-placeholder
          :rules="[required]"
          label="Your Name"
        />

        <v-text-field
          v-model="business_name"
          outlined dense persistent-placeholder
          :rules="[required]"
          label="Business Name"
        />

        <PasswordField
          v-model="password"
          outlined dense persistent-placeholder
          label="Password" 
          :rules="[required, valid_password]"
        />

        <PasswordField
          v-model="confirm"
          outlined dense persistent-placeholder
          label="Confirm Password" 
          :rules="[required, matches_password]"
        />

        <div class="px-3">
          <div class="pb-2" style="font-size: 12px;">
            By checking the box below, I acknowledge that I have <strong>read</strong> and
            <strong>agree</strong> to the terms of the Referra
            <router-link :to="{ name: 'login/tos' }">Pro Terms of Service</router-link> and
            <router-link :to="{ name: 'login/privacy' }">Privacy Policy</router-link>
          </div>

          <v-checkbox 
            v-model="agree_to_terms"
            :rules="[required]"
            dense hide-details="true"
            class="mb-4"
          >
            <template #label>
              <div style="font-size: 14px;">
                I have read and agree.
              </div>
            </template>
          </v-checkbox>
        </div>

      </v-container>
    </v-form>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="backClick">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import PasswordField from './PasswordField'
import Progress from './progress'

import { mapActions, mapGetters } from 'vuex'
import { required, valid_password } from '@/lib/validations'

export default {
  name: 'WizardStepC',

  components: { ContentPage, PasswordField, Progress },

  data() {
    return {
      agree_to_terms: false,
      business_name: '',
      confirm: '',
      name: '',
      password: '',

      // validation rules
      required,
      valid_password,
    }
  },

  computed: {
    ...mapGetters('wizard', ['progress']),

    matches_password() {
      return v => v === this.password || 'Passwords must match'
    },
  },

  methods: {
    ...mapActions('wizard', ['updateProgress']),

    backClick() {
      this.$router.replace( { name: 'wizardB' } )
    },

    // This awful shennanigan is to get past the fact that the submit button is in the,
    // footer, and thus outside the form.
    nextClick() {
      this.$refs.form.$el.dispatchEvent(new SubmitEvent('submit')) // eslint-disable-line no-undef
    },

    async submit() {
      if (this.$refs.form.validate()) {
        let { agree_to_terms, business_name, confirm, name, password } = this

        let changes = {
          agree_to_terms,
          confirm,
          pro_user: { name, password },
          pro: { business_name },
        }

        await this.updateProgress( changes )
        this.$router.replace( { name: 'wizardD' } )
      }
    },
  },

  created() {
    this.agree_to_terms = this.progress.agree_to_terms 
    this.business_name = this.progress.pro.business_name
    this.name = this.progress.pro_user.name
    this.password = this.progress.pro_user.password
    this.confirm = this.progress.confirm
  },
}
</script>
